import React, { useCallback, useEffect, useState } from 'react'
import {
  Container,
  Options,
  GenerateNotebook,
  LettersUpDown,
  LetterUp,
  LetterDown,
  Selects,
  KeyBoard,
  Wrapper,
  Summary,
  GenerateNotebookFullScreen,
  PrintQuestionBook,
} from './styles'
import { FaRegKeyboard } from 'react-icons/fa'
import TextDropdown from '../../../../components/TextDropdown'
import { setState } from '../../../../types/setState'
import { BsListTask } from 'react-icons/bs'
import { AiOutlineFullscreen } from 'react-icons/ai'
import Expand from '../../../../assets/expand-5.svg'
import Img from 'react-webp-image'
import ModalShortcuts from '../QuestionBookComponent/ModalShortCuts'
import Print from '../../../../assets/icons/print'

interface IProps {
  itemsPerPage: number
  setItemsPerPage: setState<number>

  order: 'new' | 'old'
  setOrder: setState<'new' | 'old'>

  setFontSize(fontSize: number): void
  filtersParams?: any

  onSummaryClick(): void
  setFullScreen: setState<boolean>

  fullScreen: boolean
  setOpenModalShortcuts: setState<boolean>
  openModalShortcuts: boolean

  onPrintClick(): void
}

const OptionsNotebook: React.FC<IProps> = (props) => {
  const [font, setFont] = useState(16)

  const increaseFontSize = useCallback(() => {
    setFont((prevFontSize) => prevFontSize + 2)
  }, [])

  const decreaseFontSize = useCallback(() => {
    setFont((prevFontSize) => prevFontSize - 2)
  }, [])

  useEffect(() => {
    props.setFontSize(font)
  }, [font, props])

  function toggleFullScreen() {
    if (!document.fullscreenElement) {
      if (document.documentElement.requestFullscreen) {
        props.setFullScreen(true)
        return document.documentElement.requestFullscreen()
      }
    } else {
      if (document.exitFullscreen) {
        props.setFullScreen(false)
        return document.exitFullscreen()
      }
    }
  }

  return (
    <Container>
      <div className="mobile">
        <TextDropdown
          options={[
            { label: 'Mais recentes', value: 'new' },
            { label: 'Mais antigos', value: 'old' },
          ]}
          defaultValue="new"
          value={props.order}
          onChange={(value) => props.setOrder(value as 'new' | 'old')}
          className="text-dropdown"
        />
      </div>
      {props.fullScreen ? (
        <GenerateNotebookFullScreen onClick={toggleFullScreen}>
          <Img src={Expand} alt="expand" className="expand" />
          Voltar para visão completa
        </GenerateNotebookFullScreen>
      ) : null}
      <Options style={{ display: props.fullScreen ? 'none' : 'flex' }}>
        {!props.fullScreen ? (
          <GenerateNotebook onClick={toggleFullScreen}>
            <AiOutlineFullscreen size={22} id="fullScreen" />
            Ver em tela cheia
          </GenerateNotebook>
        ) : null}

        <Summary onClick={props.onSummaryClick} id="sumary">
          <BsListTask size={20} />
          Sumário de questões
        </Summary>
        <Wrapper>
          {props.itemsPerPage === 1 ? (
            <KeyBoard onClick={() => props.setOpenModalShortcuts(true)}>
              <FaRegKeyboard size={27} color="#BABABA" />
            </KeyBoard>
          ) : null}
          <LettersUpDown>
            <LetterUp disabled={font === 28} onClick={() => increaseFontSize()}>
              A+
            </LetterUp>
            <LetterDown disabled={font === 14} onClick={() => decreaseFontSize()}>
              A-
            </LetterDown>
          </LettersUpDown>
          <Selects>
            <TextDropdown
              options={[
                { label: 1, value: 1 },
                { label: 5, value: 5 },
                { label: 10, value: 10 },
                { label: 15, value: 15 },
                { label: 20, value: 20 },
              ]}
              defaultValue={1}
              value={props.itemsPerPage}
              onChange={(value) => props.setItemsPerPage(value as number)}
              className="text-dropdown"
              customLabel={(option) => `Questões por página: ${option.value}`}
            />
            <TextDropdown
              options={[
                { label: 'Mais recentes', value: 'new' },
                { label: 'Mais antigos', value: 'old' },
              ]}
              defaultValue="new"
              value={props.order}
              onChange={(value) => props.setOrder(value as 'new' | 'old')}
              className="text-dropdown"
            />
          </Selects>
          {/* <Settings>
            <CiSettings size={27} color="#BABABA" />
          </Settings> */}
          <PrintQuestionBook onClick={props.onPrintClick} id="print">
            <Print />
          </PrintQuestionBook>
        </Wrapper>
      </Options>
      <ModalShortcuts
        isOpen={props.openModalShortcuts}
        onClose={() => props.setOpenModalShortcuts(false)}
      />
    </Container>
  )
}

export default OptionsNotebook
